import React, { useCallback } from "react";
import { useLocalization } from "@fluent/react";
import { formatNumber, TextInput } from "@narmi/design_system";
import { formAdapters } from "../../../../../src";
import CardSelector from "../../payment_by_card/add_a_card/CardSelector";
import type { LoanPaymentFormType } from "../types";

interface Card {
  id: API.CardId | string;
  description: string;
  [key: string]: any;
}

interface CardPaymentFieldsProps {
  form: LoanPaymentFormType;
  cards: Card[];
  setCards: (cards: Card[]) => void;
  loanPayByCardFee: number;
  isCustomPayment?: boolean;
}

const CardPaymentFields = ({
  form,
  cards,
  setCards,
  loanPayByCardFee,
}: CardPaymentFieldsProps) => {
  const { l10n } = useLocalization();

  const handleCardChange = useCallback(
    (value: string) => {
      form.setFieldValue("cardUUID", value, true);

      const selectedCard = cards.find((card) => card.id === value);
      if (selectedCard) {
        form.setFieldValue(
          "paymentAccountName",
          selectedCard.description,
          true
        );
      }
    },
    [form, cards]
  );

  return (
    <div className="margin--top--l">
      {/* Card Selector */}
      <div style={{ marginBottom: "var(--space-m)" }}>
        <CardSelector
          onChange={handleCardChange}
          value={form.values.cardUUID || ""}
          error={
            form.touched.cardUUID && form.errors.cardUUID
              ? form.errors.cardUUID
              : ""
          }
          cards={cards}
          setCards={setCards}
        />
      </div>

      {/* Amount Input (always shown, disabled for preset payments) */}
      <div style={{ marginBottom: "var(--space-m)" }}>
        <TextInput
          label={l10n.getString("label-amount")}
          inputMode="decimal"
          disabled={form.values.paymentType === "amountDue"}
          {...formAdapters.amountInput(form, "amount")}
        />
      </div>

      {/* Fee Display or No-Fee Disclosure */}
      <div className="margin--top--m fontSize--s fontColor--secondary">
        {Number.isNaN(loanPayByCardFee) || loanPayByCardFee === 0
          ? l10n.getString("loan-paybycard-debit-card-disclosure")
          : l10n.getString("loan-paybycard-debit-card-with-fee-disclosure", {
              amount: formatNumber(loanPayByCardFee),
            })}
      </div>
    </div>
  );
};

export default CardPaymentFields;
